export default __webpack_public_path__ + "static/media/icon-user.d5d05975.svg";